import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ExecutiveSearchPage } from './pages/services/ExecutiveSearchPage';
import { ITRecruitmentPage } from './pages/services/ITRecruitmentPage';
import { TeamBuildingPage } from './pages/services/TeamBuildingPage';
import { CareerConsultingPage } from './pages/services/CareerConsultingPage';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  useEffect(() => {
    // Google Tag Manager - head script
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MZP5VWQ');`;
    document.head.insertBefore(script, document.head.firstChild);
    // Google Tag Manager - noscript body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-MZP5VWQ';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/services/executive-search" element={<ExecutiveSearchPage data-id="element-6" />} data-id="element-5" />
          <Route path="/services/it-recruitment" element={<ITRecruitmentPage data-id="element-8" />} data-id="element-7" />
          <Route path="/services/team-building" element={<TeamBuildingPage data-id="element-10" />} data-id="element-9" />
          <Route path="/services/career-consulting" element={<CareerConsultingPage data-id="element-12" />} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}